// Backend clamps getCmpInvoiceCreateLookups to 1000; request that ceiling so
// large chambers do not lose eligible members from invoice member selectors.
export const CMP_INVOICE_CREATE_LOOKUP_LIMIT = 1000;
